import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxPreloaderComponent} from './mx-preloader/mx-preloader.component';

@NgModule({
  imports: [
    MxButtonModule,
    MxMaterialModule,
    CommonModule
  ],
  exports: [
      MxPreloaderComponent
  ],
  declarations: [MxPreloaderComponent]
})
export class MxPreloaderModule { }
